import GLightbox from 'glightbox';

export default () => {

  const items = document.querySelectorAll('.img-glightbox');
  const lightbox = GLightbox({
    selector: '.img-glightbox'
  });

}
